import { Link } from "react-router-dom";
import { InstagramLogo } from "@phosphor-icons/react";
import { Logo } from "@/components/site/Logo";
import { LOCATIONS } from "@/data/locations";

const INSTAGRAM_URL =
    "https://www.instagram.com/treasurevalleyturf?igsh=MXdnbHdqemhjZ2Rxcw%3D%3D&utm_source=qr";

export const Footer = () => {
    return (
        <footer
            data-testid="site-footer"
            className="border-t border-white/10 bg-[#0A0E0B] py-12 text-[#EDEAE0]"
        >
            <div className="mx-auto max-w-7xl px-6 md:px-10">
                <div className="flex flex-col gap-8 border-b border-white/10 pb-8 md:flex-row md:items-start md:justify-between">
                    <div>
                        <img
                            src="/logo.png"
                            alt="Treasure Valley Turf & Greens"
                            data-testid="site-logo"
                            className="h-14 w-auto"
                            draggable="false"
                        />
                        <p className="mt-4 max-w-xs text-sm leading-relaxed text-[#98A193]">
                            Idaho's trusted artificial turf &amp; putting green
                            installer. PFAS-free, pet &amp; kid-safe, family-owned.
                        </p>
                    </div>
                    <nav aria-label="Explore" className="md:text-right">
                        <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#E3A94E]">
                            Services & guides
                        </p>
                        <ul className="mt-4 flex flex-wrap gap-x-5 gap-y-2 md:justify-end">
                            <li><Link to="/services/artificial-turf-lawns" data-testid="footer-service-lawns" className="text-sm text-[#98A193] transition-colors hover:text-[#E3A94E]">Turf Lawns</Link></li>
                            <li><Link to="/services/backyard-putting-greens" data-testid="footer-service-greens" className="text-sm text-[#98A193] transition-colors hover:text-[#E3A94E]">Putting Greens</Link></li>
                            <li><Link to="/services/pet-turf" data-testid="footer-service-pet" className="text-sm text-[#98A193] transition-colors hover:text-[#E3A94E]">Pet Turf</Link></li>
                            <li><Link to="/guides" data-testid="footer-guides" className="text-sm text-[#98A193] transition-colors hover:text-[#E3A94E]">Guides</Link></li>
                        </ul>
                        <p className="mt-6 text-xs font-bold uppercase tracking-[0.22em] text-[#E3A94E]">
                            Service areas
                        </p>
                        <ul className="mt-4 flex flex-wrap gap-x-5 gap-y-2 md:justify-end">
                            {LOCATIONS.map((l) => (
                                <li key={l.slug}>
                                    <Link
                                        to={`/service-areas/${l.slug}`}
                                        data-testid={`footer-city-${l.slug}`}
                                        className="text-sm text-[#98A193] transition-colors hover:text-[#E3A94E]"
                                    >
                                        {l.city}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </nav>
                </div>

                <div className="mt-8 flex flex-col items-start justify-between gap-6 md:flex-row md:items-center">
                    <div className="flex flex-col items-start gap-3 md:flex-row md:items-center md:gap-6">
                        <a
                            href={INSTAGRAM_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-instagram"
                            className="group inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-xs font-semibold text-[#EDEAE0] transition-all hover:border-[#E3A94E]/60 hover:text-[#E3A94E]"
                        >
                            <InstagramLogo size={16} weight="duotone" />
                            @treasurevalleyturf
                        </a>
                        <p className="text-xs text-[#98A193]">
                            © 2026 Treasure Valley Turf & Greens · All rights reserved.
                        </p>
                    </div>

                    <Link
                        to="/admin"
                        data-testid="footer-admin-link"
                        className="text-xs font-semibold text-[#98A193] transition-colors hover:text-[#E3A94E]"
                    >
                        Admin
                    </Link>
                </div>
            </div>
        </footer>
    );
};
